import { RepliersListingStyle } from './RepliersListingStyle';

export enum DirtyRepliersListingStyle {
  'BungalowRaisedITSO' = 'Bungalow Raised',
  'Storey_1AndAHalfITSO' = '1.5 Storey',
  'Storey_2ITSO' = 'Two Story',
  'Storey_2ITSO2' = '2 Storey',
  'Storey_2AndAHalfITSO' = '2.5 Storey',
  'Storey_3ITSO' = '3 Storey',
  'StackedTownhouseITSO' = 'Stacked Townhouse',
  'MultiLevelITSO' = 'Multi Level',
}

export type UnsanitizedRepliersListingStyle =
  | RepliersListingStyle
  | DirtyRepliersListingStyle;
